import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Constants } from '@base/src/app/models/constants';
import { QRIcon } from '@base/src/app/models/qr-icon.model';
import { QRTextarea } from '@base/src/app/models/qr-textarea.model';

@Component({
  selector: 'qr-textarea',
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.scss'],
})
export class TextareaComponent {
  @Input() config?: QRTextarea;
  @Input() value?: string;
  @Input() hasError?: boolean = false;
  @Input() isDisabled?: boolean = false;
  @Output() valueChange: EventEmitter<string | undefined> = new EventEmitter<
    string | undefined
  >();
  @Output() focusIn: EventEmitter<boolean> = new EventEmitter<boolean>();
  
  readonly ICON_CALENDAR_EVENT: string = Constants.ICONS.CALENDAR_EVENT;
  readonly ICON_COLOR_GREY_700: string = QRIcon.COLOR_GREY_700;
  readonly ICON_COLOR_GREY_400: string = QRIcon.COLOR_GREY_400;
  readonly ICON_COLOR_ERROR_900: string = QRIcon.COLOR_ERROR_900;
  iconColor: string = this.ICON_COLOR_GREY_700;
  ngOnChanges(): void {
    this.setIcon();
  }

  setIcon(): void {
    this.iconColor = this.ICON_COLOR_GREY_700;
    if (this.hasError) {
      this.iconColor = this.ICON_COLOR_ERROR_900;
    }
    if (this.isDisabled) {
      this.iconColor = this.ICON_COLOR_GREY_400;
    }
  }
}
